<template>
  <div
    class="form-image control-group"
    :class="{ error: error }"
  >
    <label
      class="control-label"
      :for="name"
    >
      <abbr
        v-if="required"
        title="Verplicht veld"
      >
        *
      </abbr>
      {{ label }}
    </label>
    <div class="right-side">
      <div
        v-if="value"
        class="form-image__img-wrap"
      >
        <img
          :src="value"
          @click="reset"
        >
      </div>
      <image-uploader
        v-if="isAvailable && environment !== 'registration-pdf'"
        class-name="image-input"
        accept="image/png,image/jpeg"
        :placeholder="placeholder"
        :preview="false"
        :max-width="512"
        :quality="0.8"
        :max-size="0.2"
        :output-format="'string'"
        @input="onLoad"
      />
      <div v-else>
        <span>Bestand als bijlage toevoegen svp</span>
      </div>
    </div>
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
import ImageUploader from 'vue-image-upload-resize';

export default {
  name: 'FormImage',

  components: {
    ImageUploader,
  },

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'placeholder',
      default: 'Kies een document',
      type: 'formText',
      label: 'Placeholder',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => (null),
    },
    environment: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isAvailable: true,
    };
  },

  methods: {
    onLoad(value) {
      this.isAvailable = false;
      this.$emit('input', value);
    },
    reset() {
      this.$emit('input', '');
      this.isAvailable = true;
    },
  },
};
</script>

<style lang="scss">
.form-image {
  display: flex;
  flex-grow: 1;
  overflow: hidden;

  .right-side {
    width: 50%;

    .form-image__img-wrap {
      position: relative;
      align-items: center;
      display: flex;
      justify-content: center;

      &:hover::after {
        align-items: center;
        background: rgba(100, 100, 100, 0.5);
        bottom: 0;
        color: white;
        content: 'Klik om te resetten';
        display: flex;
        font-size: 20px;
        justify-content: center;
        left: 0;
        line-height: 22px;
        position: absolute;
        right: 0;
        top: 0;
        pointer-events: none;
      }

      img {
        // margin-bottom: 10px;
        max-height: 565px;
        max-width: 565px;
      }
    }
  }

  label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    // margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  & > div {
    // width: 50%;
    // margin-right: 10px;
  }

  img {
    float: right;
  }

  .vue-base64-file-upload {
    input {
      width: initial !important;
    }
  }
}

.print-form-structures {
  img {
    margin-top: 40px;
  }

  .vue-base64-file-upload {
    height: 0;
    overflow: hidden;
  }
}
</style>
